import React from 'react';

import { Group, Text } from '@mantine/core';
import AthleteStatusBadge from 'components/status-badges/AthleteStatusBadge';

interface IAthleteNameCellProps {
  name: string;
  isTrial: boolean;
}

const AthleteNameCell = ({ name, isTrial }: IAthleteNameCellProps): JSX.Element => (
  <Group spacing='xs' noWrap>
    <Text>{name}</Text>
    {isTrial && <AthleteStatusBadge status='Trial' size='xs' />}
  </Group>
);

export default AthleteNameCell;
